import { render, staticRenderFns } from "./SourceOfIncomePreviewPopup.vue?vue&type=template&id=399028ca&"
import script from "./SourceOfIncomePreviewPopup.vue?vue&type=script&lang=js&"
export * from "./SourceOfIncomePreviewPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports